var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styled from 'styled-components';
const CarouselContainer = styled.div `
  width: 100%;
  margin: ${props => (props.margin ? props.theme.paddingsMargins.themeMargin : 'none')};
  display: flex;
  flex-direction: column;
  aling-items: center;
  justify-content: center;
`;
const CarouselElements = styled.div `
  text-align: center;
  padding: ${props => props.theme.paddingsMargins.themePadding};
  display: flex;
  flex-direction: column;
  aling-items: center;
  justify-content: center;
`;
const CarouselElement = styled.div `
  opacity: 1;
  font-family: ${props => props.theme.fonts.fontFamily};
  ${''} color : ${props => props.theme.utils.getColor(props.color)};
  ${''} font-size: ${props => props.theme.utils.getSize(props.size)};
`;
const CarouselSteps = styled.div `
  display: flex;
  justify-content: center;
  aling-items: center;
`;
const CarouselStep = styled.div `
  cursor: pointer;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: ${props => props.isActive ? props.theme.colors.mainColor : props.theme.colors.greyColor};
  &:not(:last-child) {
    margin-right: 0.4rem;
  }
`;
const Carousel = (_a) => {
    var { elements, color = 'main', size = 'article', slideTime = 3000, isImage = false, imageStyle = {}, margin = true, hideSteps = false } = _a, props = __rest(_a, ["elements", "color", "size", "slideTime", "isImage", "imageStyle", "margin", "hideSteps"]);
    const [currentStep, setCurrentStep] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            if (currentStep === elements.length - 1) {
                setCurrentStep(0);
            }
            else {
                setCurrentStep(currentStep => currentStep + 1);
            }
        }, slideTime);
        return () => clearInterval(timer);
    }, [currentStep, elements, slideTime]);
    return (_jsxs(CarouselContainer, Object.assign({ margin: margin }, props, { children: [isImage
                ? _jsx("img", { src: elements[currentStep], alt: elements[currentStep], style: imageStyle })
                : _jsx(CarouselElements, { children: _jsx(CarouselElement, Object.assign({ color: color, size: size }, { children: elements[currentStep] })) }), !hideSteps && _jsx(CarouselSteps, { children: elements.map((_, i) => _jsx(CarouselStep, { onClick: () => setCurrentStep(i), isActive: currentStep === i }, i)) })] })));
};
export default Carousel;
